var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11428",
    "data-name": "Group 11428",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.229,
    height: 5.2,
    viewBox: "0 0 9.229 5.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M1448.17,597.284l4.025,4.025a.59.59,0,0,0,.832,0l4.025-4.025a.588.588,0,0,0-.416-1h-8.056A.588.588,0,0,0,1448.17,597.284Z",
    transform: "translate(-1447.997 -596.28)",
    fill: "#1b2027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.7fec4320cc4af6d97b66aa5cc4d04e65.svg";
export { ForwardRef as ReactComponent };